function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Typography, Space, Select, Tag, Drawer, Input, Form, Statistic, DatePicker } from 'antd';
import { Table } from 'react-bootstrap';
import { CheckCircleFill, PersonVcardFill, PrinterFill } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import Moment from "react-moment";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import Card from "../components/Card";
import DisplayMultiplePage from "../components/DisplayMultiplePage";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Text = Typography.Text,
  Link = Typography.Link;
var Validated = function Validated() {
  var ref = useRef();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    compList = _useState4[0],
    setCompList = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    compOptions = _useState6[0],
    setCompOptions = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    companyId = _useState8[0],
    setCompanyId = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    company = _useState0[0],
    setCompany = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    customers = _useState10[0],
    setCustomers = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    currentCustomer = _useState12[0],
    setCurrentCustomer = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showCertificate = _useState14[0],
    setShowCertificate = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    dataChanged = _useState16[0],
    setDataChanged = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showDisplayData = _useState18[0],
    setShowDisplayData = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    file = _useState20[0],
    setFile = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showCard = _useState22[0],
    setShowCard = _useState22[1];
  var _useState23 = useState(0),
    _useState24 = _slicedToArray(_useState23, 2),
    currentTotal = _useState24[0],
    setCurrentTotal = _useState24[1];
  var _useState25 = useState(0),
    _useState26 = _slicedToArray(_useState25, 2),
    currentPending = _useState26[0],
    setCurrentPending = _useState26[1];
  var _useState27 = useState(0),
    _useState28 = _slicedToArray(_useState27, 2),
    currentCerts = _useState28[0],
    setCurrentCerts = _useState28[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState29 = useState(20),
    _useState30 = _slicedToArray(_useState29, 2),
    limit = _useState30[0],
    setLimit = _useState30[1];
  var _useState31 = useState(0),
    _useState32 = _slicedToArray(_useState31, 2),
    offset = _useState32[0],
    setOffset = _useState32[1];
  var _useState33 = useState("0"),
    _useState34 = _slicedToArray(_useState33, 2),
    keyword = _useState34[0],
    setKeyword = _useState34[1];
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var handleKewordChange = function handleKewordChange(v) {
    setKeyword(v.target.value);
  };
  var handleMore = function handleMore() {
    setLimit(function (prev) {
      return prev + 20;
    });
  };
  var handleCompanyChange = function handleCompanyChange(v) {
    setCompany(compList.filter(function (c) {
      return c.id == v;
    })[0]);
    setCompanyId(compList.filter(function (c) {
      return c.id == v;
    })[0].id);
    localStorage.setItem("defaultCompany", compList.filter(function (c) {
      return c.id == v;
    })[0].id);
  };
  var items = [{
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CheckCircleFill, {
        size: 24
      }), " DOSSIERS TERMINES"]
    }),
    key: 1,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "A/I"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "NUMERO"
            }), /*#__PURE__*/_jsx("th", {
              children: "POSTE"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.conclusion != null && c.status == 1;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [c.conclusion.conclusion == 1 || c.conclusion.conclusion == 2 || c.conclusion.conclusion == 3 || c.conclusion.conclusion == 7 || c.conclusion.conclusion == 8 || c.conclusion.conclusion == 9 || c.conclusion.conclusion == 10 || c.conclusion.conclusion == 11 ? /*#__PURE__*/_jsx("div", {
                    style: {
                      width: "6px",
                      borderRadius: "6px",
                      height: "6px",
                      background: "cyan"
                    },
                    color: "cyan",
                    bordered: false
                  }) : /*#__PURE__*/_jsx("div", {
                    style: {
                      width: "6px",
                      borderRadius: "6px",
                      height: "6px",
                      background: "red"
                    },
                    color: "cyan",
                    bordered: false
                  }), /*#__PURE__*/_jsx("span", {
                    children: c.candidate_code
                  })]
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.conclusion.conclusion == 1 || c.conclusion.conclusion == 2 || c.conclusion.conclusion == 3 || c.conclusion.conclusion == 7 || c.conclusion.conclusion == 8 || c.conclusion.conclusion == 9 || c.conclusion.conclusion == 10 || c.conclusion.conclusion == 11 ? /*#__PURE__*/_jsx("div", {
                  children: "A"
                }) : /*#__PURE__*/_jsx("div", {
                  children: "I"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.mobile_first
              }), /*#__PURE__*/_jsx("td", {
                children: c.job
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowCertificate(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CERTIFICAT"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowCard(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(PersonVcardFill, {
                        size: 24
                      })
                    })
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }];
  var loadData = function loadData(cid) {
    setIsDataLoading(true);
    if (cid == null) return;
    axios.post("".concat(Common.baseApiUrl, "getvalidatedcompanycostumers"), {
      company_id: cid,
      user_id: Common.currentUser.id,
      limit: limit,
      offset: offset,
      keyword: keyword
    }).then(function (response) {
      setCustomers(response.data.customers);
      setCurrentTotal(response.data.currentTotal);
      setCurrentPending(response.data.currentPending);
      setCurrentCerts(response.data.currentCerts);
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getcompanylist').then(function (response) {
      if (response.data.status == 200) {
        setCompOptions([]);
        response.data.companyList.forEach(function (c) {
          setCompOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
        setCompList(response.data.companyList);
        setCompanyId(response.data.companyList[0].id);
        setCompany(response.data.companyList[0]);
        if (response.data.companyList.length > 0) {
          if (localStorage.getItem("defaultCompany") != null && localStorage.getItem("defaultCompany") != 'undefined') {
            form.setFieldsValue({
              comp: parseInt(localStorage.getItem("defaultCompany"))
            });
          } else {
            form.setFieldsValue({
              comp: response.data.companyList[0].id
            });
            localStorage.setItem("defaultCompany", response.data.companyList[0].id);
          }
        }
        loadData(localStorage.getItem("defaultCompany"));
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  useEffect(function () {
    loadData(companyId);
  }, [companyId, dataChanged, limit, keyword, offset]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Text, {
            mark: true,
            children: /*#__PURE__*/_jsx("b", {
              children: "#DOSSIER VALIDES"
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsx(Form, {
            form: form,
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "comp",
                children: /*#__PURE__*/_jsx(Select, {
                  options: compOptions,
                  onChange: handleCompanyChange,
                  style: {
                    width: "200px"
                  }
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Input, {
                  onChange: handleKewordChange,
                  placeholder: "Code dossier"
                })
              })]
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                sm: 6,
                children: /*#__PURE__*/_jsx("div", {
                  className: "infoBox",
                  style: {
                    background: "#E1E1CD"
                  },
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: /*#__PURE__*/_jsx("b", {
                      children: "TOTAL DOSSIER"
                    }),
                    value: currentTotal
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                sm: 6,
                children: /*#__PURE__*/_jsx("div", {
                  className: "infoBox",
                  style: {
                    background: "#E1CECC"
                  },
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: /*#__PURE__*/_jsx("b", {
                      children: "TOTAL EN COURS"
                    }),
                    value: currentPending
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                sm: 6,
                children: /*#__PURE__*/_jsx("div", {
                  className: "infoBox",
                  style: {
                    background: "#D9CDE0"
                  },
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: /*#__PURE__*/_jsx("b", {
                      children: "TOTAL CERTIFICAT(S)"
                    }),
                    value: currentCerts
                  })
                })
              })]
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Tabs, {
            items: items,
            animated: true,
            defaultActiveKey: 1
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
            style: {
              textAlign: "center"
            },
            children: /*#__PURE__*/_jsx(Button, {
              loading: isDataLoading,
              type: "default",
              onClick: handleMore,
              children: /*#__PURE__*/_jsx("b", {
                children: "VOIR PLUS"
              })
            })
          })]
        })
      })]
    }), currentCustomer && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        open: showCertificate,
        title: /*#__PURE__*/_jsx("b", {
          children: "CERTIFICAT D'APTITUDE"
        }),
        width: "80%",
        onClose: function onClose() {
          setShowCertificate(false);
        },
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref) {
              var handlePrint = _ref.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsx("b", {
                  children: "IMPRIMER"
                })
              });
            }
          })
        })],
        destroyOnClose: true,
        children: currentCustomer.conclusion && /*#__PURE__*/_jsx(DisplayMultiplePage, {
          pageCount: 1,
          file_url: currentCustomer.conclusion.file
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "MEDVITALE CARTE DE VIE"
        }),
        width: "60%",
        open: showCard,
        extra: /*#__PURE__*/_jsx(Space, {
          children: /*#__PURE__*/_jsx(ReactToPrint, {
            content: function content() {
              return ref.current;
            },
            children: /*#__PURE__*/_jsx(PrintContextConsumer, {
              children: function children(_ref2) {
                var handlePrint = _ref2.handlePrint;
                return /*#__PURE__*/_jsx(Button, {
                  size: "large",
                  type: "primary",
                  onClick: handlePrint,
                  children: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(PrinterFill, {
                      size: 22
                    }), " IMPRIMER"]
                  })
                });
              }
            })
          })
        }),
        onClose: function onClose() {
          setShowCard(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(Card, {
          ref: ref,
          candidat: currentCustomer
        })
      })]
    })]
  });
};
export default Validated;